import React from 'react';
import { IonPage, IonContent, IonImg } from '@ionic/react';
import { CapacitorHttp, HttpOptions } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

import './Page.css';

const logoUrl = "https://browsedns.net/assets/uploads/system/site-logo.png";
const registerUrl = "https://browsedns.net/register";
const resetUrl = "https://browsedns.net/reset";

const loginEndpoint = "https://api.browsedns.net/api/v3/utilities/login";

const Login: React.FC = () => {

    const performLogin = async () => {
        const form = document.querySelector("form");
        if (form) {
            const formData = new FormData(form);
            const username = formData.get("username") as string;
            const password = formData.get("password") as string;

            const options: HttpOptions = {
                url: loginEndpoint,
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                data: {
                    username,
                    password
                }
            };
            
            CapacitorHttp.post(options).then(response => {
                const { status, data, headers } = response;
                // alert(`Response: ${JSON.stringify(response)}`);
                if (status !== 200) {
                    alert(`Login failed. Please try again. Status: ${response.status}`);
                    return;
                }
                if (data && data.status && data.status.code === "ok") {
                    const { response: innerResponse } = data;
                    // save the login data to local storage
                    localStorage.setItem("loginData", JSON.stringify(innerResponse));
                    localStorage.setItem("loginTime", new Date().toISOString());
                    localStorage.setItem("loginHeaders", JSON.stringify(headers));
                    // redirect to the main page
                    window.location.href = "/";
                }
            }).catch(() => {
                alert("Login failed. Please try again.");
            });
        }
    }
   
    return <IonPage>
    <IonContent>
      <div className="container">
        <div className="login-form">
            <IonImg className="logo" src={logoUrl} alt="BrowseDNS Logo" />
            <h2>BrowseDNS Chat</h2>
            <form>
                <div className="input-caption">Username / Email</div>
                <input type="text" placeholder="Username / Email" name="username" />
                <div className="input-caption">
                    <span>Password</span>
                    <a
                        href="#"
                        onClick={async (e) => {
                            e.preventDefault();
                            await Browser.open({ url: resetUrl, presentationStyle: "popover" });
                        }}
                    >Forgot Password?</a>
                </div>
                <input type="password" placeholder="Password" name="password" />
            <button
                onClick = {async (e) => {
                    e.preventDefault();
                    performLogin();
                }}
            >Login</button>
            <div className="input-caption">Don&apos;t have an account?</div>
            <button
                onClick={async (e) => {
                    e.preventDefault();
                    await Browser.open({ url: registerUrl, presentationStyle: "popover" });
                }}
            >Register</button>
            </form>
        </div>
      </div>
    </IonContent>
  </IonPage>;
};

export default Login;